import { createJsonHttpRequest, authTokenHandler, zipkinTraceHandler } from '@jutro/transport';
import { getConfigValue } from '@jutro/config';
const zipkinHandler = zipkinTraceHandler('TSM', 'Jutro with TSM');
export const createTSMRequest = serverUrl => createJsonHttpRequest(serverUrl, false).addHandler(zipkinHandler).addHandler(authTokenHandler);
export const isTSMEnabled = () => getConfigValue('JUTRO_AUTH_ENABLED', false) && getConfigValue('JUTRO_TSM_ENABLED', false);